//
// class for time data type
//
// @extends [DataFormatterType]
//
import { DataFormatterType } from '../DataFormatterType';
import { DataFormatterOptions } from '../DataFormatterType';
import { DataTools } from '../../utils/DataTools';

/**
 * Data formatter for general time types
 * @ignore
 */
export class DataFormatTime extends DataFormatterType {
    constructor(...args: any[]) {
        super();
    }

    getName(): string {
        return 'time';
    }

    /* Return option text to the right of the display value */
    getUnitText(options?: DataFormatterOptions): string {
        return '';
    }

    /* Default options for the date formatter */
    initializeOptions(): DataFormatterOptions {
        return {};
    }

    /**
     * funtion to format the currently passed data
     *
     * @param {object} data data to be formatted
     * @param {object} options additonal options defined for the datatype
     * @param {string} path path where the value is being edited
     * @return {object} data formatted data
     */
    format(data: any, options: any, path: any) {
        if (!data) return '';

        let value = this.unformat(data);
        if (!value) return '';
        return value;
    }

    // Text alignment default
    getAlign(): string {
        return 'right';
    }

    /**
     * Format the data for export.  As this is a basic type, we want CSV files
     * to have the raw number value.
     *
     * @param {object} data
     * @param {object} options
     * @param {object} refObj
     */
    formatExport(data: any, options?: DataFormatterOptions, refObj?: any): any {
        return DataTools.getNumber(data);
    }

    localFormat(hh: number, mm: number): string {
        return `${this.getTwoDigitHours(hh)}:${this.getTwoDigitHours(mm)}`;
    }
    /**
     * Convert an hour value to 2 digit string
     * @param hour An hour value to convert
     * @example "05"
     */
    getTwoDigitHours(hour: number): string {
        const twoDigitHour = ('0' + hour).slice(-2);
        return twoDigitHour;
    }
    /**
     * funtion to unformat the currently formatted data
     * @param {object} data data to be unformatted
     * @return {object} data unformatted data
     */
    unformat(data: any, format?: string): string | undefined {
        if (!data) return undefined;

        if (typeof data === 'string') {
            // Look for a hh:mm format first
            const match = data.match('([0-1]?[0-9]|2[0-3])[:/]([0-5][0-9])');
            if (match) {
                const hh = parseInt(match[1], 10);
                const mm = parseInt(match[2], 10);
                return this.localFormat(hh, mm);
            }
        }

        if (data && typeof data === 'object' && data.getTime) {
            const date = new Date(data);
            const match = DataTools.getMoment(date)
                ?.toString()
                .match('([0-1]?[0-9]|2[0-3])[:/]([0-5][0-9])');
            if (match) {
                const hh = parseInt(match[1], 10);
                const mm = parseInt(match[2], 10);
                return this.localFormat(hh, mm);
            }
        }

        const m = DataTools.getMoment(data, format);
        if (m == null) {
            return undefined;
        }

        let d = m.toDate();
        let hh = d.getHours();
        let mm = d.getMinutes();
        return this.localFormat(hh, mm);
    }
}

export default DataFormatTime;
